<template>
<el-dialog title="任务Cron变更" :visible.sync="dialogCornVisible" :close-on-click-modal="false" @open="open()">
   <el-form>
    <el-form-item label="调度周期" label-width="100px" required>
        <el-input v-model="retaskcron" autocomplete="off" ></el-input>
    </el-form-item>
   </el-form>
   <div slot="footer" class="dialog-footer">
    <el-button @click="cancel()">取 消</el-button>
    <el-button type="primary" @click="updataCorn()">确 定</el-button>
   </div>
</el-dialog>
</template>
<script>
import Utility from '@/components/mixin.js'
import axios from 'axios'
export default{
    mixins: [Utility],
    props:{
        taskData:Object
    },
    data () {
        return {
            retaskcron:'',
            dialogCornVisible:false
        }
    },
    mounted(){
       
    },
    methods:{
        open(){
             this.retaskcron=this.taskData.taskcron
        },
        updataCorn(){
            if(this.retaskcron!=''){
                this.taskData.taskcron = this.retaskcron
                let req={
                    taskid:this.taskData.taskid,
                    taskcron:this.taskData.taskcron
                }
                axios.post('/mananger/task/cron?token='+this.usrinfo.token,req)
                  .then(response=>{
                      let res = response.data
                      if(res.code === 1){
                           console.log(this.taskData.taskcron);
                           this.dialogCornVisible = false
                      }else{
                           this.err_process(res.code, '[' + res.code + ']' + res.message)
                      }
                  }).catch(err => {
                    console.error(err)
                    this.err_process('AAAA', '修改数据异常:[AAAA]' + err)
               })
            }else{
                 this.$alert('调度周期不能为空', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                    });
            }
        },
        cancel(){
            this.dialogCornVisible = false
        }
    }
}
</script>
